import { Component, uiElement, uiEvent } from "@kluntje/core";
import { toggleClass } from "@kluntje/js-utils/lib/dom-helpers";
import { HIDDEN_HEADER } from "Constants/cssClasses";
import NavigationService from "Services/NavigationService";
import WindowScrollService from "Services/WindowScrollService";
export class SDEHeader extends Component {
  private _headerHeight = this.getBoundingClientRect().height;

  @uiElement(".sde-m-header__nav-toggle")
  protected navToggle: HTMLButtonElement;

  private get headerHeight(): number {
    return this._headerHeight;
  }

  private set headerHeight(newValue: number) {
    if (this._headerHeight === newValue) return;
    this._headerHeight = newValue;
    this.updateHeaderHeight();
  }

  private get isHidden(): boolean {
    const wasScrolledUp = WindowScrollService.scrollDirection === "UP";
    if (WindowScrollService.preventHeaderGrow) return true;
    if (WindowScrollService.preventHeaderShrink) return false;
    return !(wasScrolledUp === true || document.documentElement.scrollTop <= 90);
  }

  protected afterComponentRender(): void {
    WindowScrollService.observeScroll(() => this.handleWindowScroll());
    this.initResizeObserver();
    this.updateHeaderHeight();
  }

  private initResizeObserver() {
    const resizeObserver = new ResizeObserver(() => {
      this.headerHeight = this.getBoundingClientRect().height;
    });
    resizeObserver.observe(this);
  }

  @uiEvent("navToggle", "click")
  protected handleNavToggleClick() {
    NavigationService.openNavigation();
  }

  private handleWindowScroll() {
    toggleClass(document.body, HIDDEN_HEADER, this.isHidden);
  }

  private updateHeaderHeight() {
    document.documentElement.style.setProperty("--vic-header-height", `${this.headerHeight}px`);
  }
}

customElements.define("sde-m-header", SDEHeader);
